module.exports = __webpack_public_path__ + "img/4.332dd2d.svg";